import { MAP_TYPES } from '@deck.gl/carto';

const MIRAMARDEVELOPMENTPROJECT_SOURCE_ID = 'miramarDevelopmentProjectSource';

const source = {
  id: MIRAMARDEVELOPMENTPROJECT_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Miramar_Development_Projects_2024_Parcel`,
};

export default source;
